export const microCardActivation = {
    enabled: true,
    _description: 'Enables the micro card activation feature on bank card settings page.',
};
